import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_CAPITALSTATE}`

const fetchCarteraCliente = (query) => http.get(`${api}/operation/cartera-clientes`, { params: { ...query } })

export {
  fetchCarteraCliente
}
